import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { wakeServer } from "@/lib/api";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Location from "@/pages/Location";
import Pricing from "@/pages/Pricing";
import AddOns from "@/pages/AddOns";
import Reviews from "@/pages/Reviews";
import Maintenance from "@/pages/Maintenance";
import CustomPlan from "@/pages/CustomPlan";
import Terms from "@/pages/Terms";
import BookNow from "@/pages/BookNow";
import Deals from "@/pages/Deals";
import Reschedule from "@/pages/Reschedule";
import ServiceDetail from "@/pages/ServiceDetail";
import ScrollToTop from "@/components/ScrollToTop";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import AdminConsole from "@/pages/AdminConsole";

function AdminGate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) return <AdminLogin />;
  return <AdminConsole />;
}

function App() {
  useEffect(() => {
    // Wake the backend as soon as someone is on the site (handles cold starts).
    wakeServer();
  }, []);
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/location/:slug" element={<Location />} />
          <Route path="/services/:type" element={<ServiceDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/add-ons/:category" element={<AddOns />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/custom-plan" element={<CustomPlan />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/reschedule" element={<Reschedule />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminGate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
